<template>
  <ConfigProvider :locale="locale">
    <router-view/>
  </ConfigProvider>
</template>

<script>
import {
  ConfigProvider
} from 'ant-design-vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
export default {
  components: {
    ConfigProvider
  },
  data () {
    return {
      locale: zhCN
    }
  }
}
</script>

<style lang="scss">
.breadcrumb{
  padding-bottom: 20px;
}
</style>
